module.exports = __webpack_public_path__ + "static/media/gsb-iconService.5baa29b8.svg";